module.exports = __webpack_public_path__ + "img/protect.36b02d2e.png";